import {DatePipe} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {CardModule} from 'primeng/card';
import {ProfileInfo} from '../../../entities/underwriting-page-object/profile-info';
import {ProtectionSummaryComponent} from '../protection-summary.component';

@Component({
  selector: 'em-profile-info',
  templateUrl: './profile-info.component.html',
  imports: [ProtectionSummaryComponent, CardModule, DatePipe, RouterLink],
})
export class ProfileInfoComponent {
  @Input({required: true}) profileInfo!: ProfileInfo;
}
